import {
    GET_CONFIG,
    SET_CONFIG,
    FETCH_SERVICE_VISIBILITY_CONFIG,
    UPDATE_SERVICE_VISIBILITY_CONFIG
} from '@/redux/actions/types';

/**
 * initial state
 */
const INIT_STATE = {
    roles: [],
    serviceVisibility: null
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_CONFIG: {
            return {
                ...action.payload,
                serviceVisibility: state.serviceVisibility
            }
        }
        case SET_CONFIG: {
            return {
                ...state
            }
        }
        case FETCH_SERVICE_VISIBILITY_CONFIG: {
            return {
                ...state,
                serviceVisibility: action.payload
            }
        }
        case UPDATE_SERVICE_VISIBILITY_CONFIG: {
            return {
                ...state,
                serviceVisibility: {
                    ...(state.serviceVisibility || {}),
                    ...action.payload
                }
            }
        }
        default: return { ...state };
    }
}
